<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/packing_house/quality_control/process/list_inspects.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ph_quality_control_process_list_templates_path"
    :params="{
      packing_house_process_id: packing_house_process_id,
      harvested_batch_id: harvested_batch_id,
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[
      module_name,
      packing_house_process?.name,
      harvested_batch?.batch_code,
      quality_template?.name,
    ]"
  ></bread-crumbs>

  <div>
    <harvested-batch-info
      v-if="harvested_batch && render_list"
      :harvested_batch="harvested_batch"
    ></harvested-batch-info>

    <!-- <tabs-container v-if="option_tabs.length > 0" v-model="option_tabs" /> -->

    <div class="mt-6">
      <!-- <h1 class="page-title">
        <i class="fa-solid fa-list-check"></i><span class="space-icon"></span>
        {{ option_tab.name }}
      </h1> -->

      <!-- <tabs-container v-model="option_tabs_templates" /> -->

      <div v-show="option_tabs_templates[0].current">
        <div class="mt-8 flex flex-row justify-end">
          <!-- <button
            type="button"
            @click.prevent="downloadRepXlsx()"
            class="btn-white"
          >
            <i class="fa-solid fa-file-excel"></i
            ><span class="space-icon"></span
            >{{ $t("labels.general_report_button") }}
          </button>
          <span class="space-actions" /> -->
          <new-button
            @click.prevent="goToNewInspection"
            :label="$t('labels.add_link')"
          />
        </div>

        <inspection-details
          v-if="render_list && quality_template"
          :quality_inspects="quality_inspects"
          :goToShow="goToShowInspect"
          :quality_template="quality_template"
        ></inspection-details>
        <loading-message v-else />
      </div>

      <h1 v-show="option_tabs_templates[1].current" class="page-title">
        <!-- <inspection-graphics
          v-if="quality_inspects.length && quality_template"
          :max_amplings="maxSamplings(quality_inspects)"
          :quality_inspects="quality_inspects"
          :template="quality_template"
        ></inspection-graphics> -->
      </h1>
    </div>
  </div>
  <div></div>
</template>

<script>
import ContainerQualityRequester from "@/views/packing_house/requesters/quality_control/process/list_inspects.js";
import GoBackLink from "@/components/views/layout/GoBackLink.vue";
import HarvestedBatchInfo from "@/components/views/packing_house/quality_control/process/HarvestedBatchInfo.vue";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
import InspectionDetails from "@/components/views/packing_house/quality_control/process/InspectionDetails.vue";
// import InspectionGraphics from "@/components/views/packing_house/quality_control/process/InspectionGraphics.vue";

export default {
  name: "ListInspects",
  components: {
    GoBackLink,
    HarvestedBatchInfo,
    BreadCrumbs,
    InspectionDetails,
    // InspectionGraphics,
  },
  data() {
    return {
      render_list: false,
      packing_house_process: {},
      harvested_batch: null,
      quality_inspects: [],
      quality_template: null,
      quality_templates: [],
      option_tabs: [],
      option_tabs_templates: [
        {
          name: "Inspecciones",
          current: true,
          icon: "fa-solid fa-list-ul",
        },
        {
          name: "Gráficos",
          current: false,
          icon: "fa-solid fa-chart-line-up",
        },
      ],
    };
  },
  props: {
    packing_house_id: {
      required: true,
    },
    packing_house_process_id: {
      required: true,
    },
    harvested_batch_id: {
      required: true,
    },
    packing_process_quality_template_id: {
      required: true,
    },
    current_tab: {},
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id
        }
      }).then(() => {
        this.checkIfAuthenticated();
        this.fetchPackingHouseProcess();
        this.fetchHarvestedBatch();
        this.fetchExporterQualityTemplate();
        this.fetchQualityInspects();
      })
    );

  },
  methods: {
    inspectsByTemplate: function (current_tab_id) {
      return this.quality_inspects.filter(
        (eq_inspect) =>
          eq_inspect.quality_template_id === current_tab_id
      );
    },
    maxSamplings: function (arr) {
      return Math.max(...arr.map((eq_inspect) => eq_inspect.samplings));
    },
    fetchPackingHouseProcess: async function () {
      let response = await ContainerQualityRequester.fetchPackingHouseProcess({
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id,
      });
      this.packing_house_process = response.data;
    },
    downloadRepXlsx: async function () {
      try {
        let response =
          await ContainerQualityRequester.downloadQualityInspectsRepXlsx({
            harvested_batch_id: this.harvested_batch_id,
            quality_template_id: this.quality_template.id,
          });

        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        let name = this.quality_template?.name;
        if (name) name = `${name.split(" ").join("_")}.xlsx`;
        fileLink.setAttribute("download", name ?? "reporte.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
    },
    fetchHarvestedBatch: async function () {
      let response = await ContainerQualityRequester.fetchHarvestedBatch({
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id,
        harvested_batch_id: this.harvested_batch_id,
      });
      this.harvested_batch = response.data;
    },
    fetchQualityInspects: async function () {
      let response = await ContainerQualityRequester.fetchExportQualityInspects(
        this.harvested_batch_id,
        this.packing_process_quality_template_id
      );
      this.quality_inspects = response.data;
      this.render_list = true;
    },
    fetchExporterQualityTemplate: async function () {
      let response =
        await ContainerQualityRequester.fetchExporterQualityTemplate({
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          packing_process_quality_template_id:
            this.packing_process_quality_template_id,
        });
      this.quality_template = response.data;
      // this.option_tabs = this.quality_templates.map((item, index) => {
      //   return {
      //     id: item.id,
      //     name: item.name,
      //     icon: "",
      //     current: this.switchTab(index),
      //   };
      // });
    },
    switchTab: function (index) {
      if (this.current_tab) return Number(this.current_tab) === index;
      return index == 0;
    },
    goToShowInspect: function (quality_inspect) {
      this.$router.push({
        name: "ph_quality_control_process_show_inspect_path",
        params: {
          harvested_batch_id: this.harvested_batch_id,
          packing_house_process_id: this.packing_house_process_id,
          packing_house_id: this.packing_house_id,
          packing_process_quality_template_id:
            this.packing_process_quality_template_id,
          quality_inspect_id: quality_inspect.id,
        },
      });
    },
    goToNewInspection: function () {
      this.$router.push({
        name: "ph_quality_control_process_new_inspect_path",
        params: {
          harvested_batch_id: this.harvested_batch_id,
          quality_template_id: this.quality_template?.id,
          packing_house_process_id: this.packing_house_process_id,
          packing_house_id: this.packing_house_id,
          packing_process_quality_template_id:
            this.packing_process_quality_template_id,
        },
      });
    },
  },
};
</script>
